import { EvaneosThemeProvider } from '@evaneos/b2b-ui';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Userpilot } from 'userpilot';

import { Notifications } from '../../../design-system/Notifications';
import { TranscriptStatusNotification } from '../../../pages/Dossier/Phoning/TranscriptNotification/TranscriptStatusNotification';
import { TranscriptGenerationProvider } from '../../providers/TranscriptGenerationProvider';
import { FiltersDrawerProvider } from '../../providers/FiltersDrawerContext';
import { RequestManagerRoutes } from '../../routing/RequestManagerRoutes';
import { setTheme, toastConfig } from '../../../styles/theme';
import { AppErrorBoundary } from '../ErrorBoundary/AppErrorBoundary';

import s from './app.module.css';
import { LayoutNavbar } from './Navbar';

export const RequestManagerLayout = (): JSX.Element => {
    const location = useLocation();

    useEffect(() => {
        Userpilot.reload();
    }, [location]);

    return (
        <EvaneosThemeProvider rootHtmlFontSize={10} setTheme={setTheme} toastConfig={toastConfig}>
            <TranscriptGenerationProvider>
                <FiltersDrawerProvider>
                    <div id="app-container" className={s.appContainer}>
                        <LayoutNavbar />
                        <main className={s.children}>
                            <AppErrorBoundary key={location.pathname}>
                                <RequestManagerRoutes />
                            </AppErrorBoundary>
                        </main>
                        <Notifications />
                        <TranscriptStatusNotification />
                    </div>
                </FiltersDrawerProvider>
            </TranscriptGenerationProvider>
        </EvaneosThemeProvider>
    );
};
